"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEM_TYPE = exports.TAG_TO_TYPE = exports.TYPE_TO_TAG = exports.TAGS = void 0;
var TAGS;
(function (TAGS) {
    TAGS[TAGS["void_tag"] = 0] = "void_tag";
    TAGS[TAGS["float_tag"] = 1] = "float_tag";
    TAGS[TAGS["int_tag"] = 2] = "int_tag";
    TAGS[TAGS["char_tag"] = 3] = "char_tag";
    TAGS[TAGS["float_pointer_tag"] = 4] = "float_pointer_tag";
    TAGS[TAGS["int_pointer_tag"] = 5] = "int_pointer_tag";
    TAGS[TAGS["char_pointer_tag"] = 6] = "char_pointer_tag";
    TAGS[TAGS["pointer_tag"] = 7] = "pointer_tag";
    TAGS[TAGS["Unassigned_tag"] = 8] = "Unassigned_tag";
    TAGS[TAGS["base_pointer_tag"] = 9] = "base_pointer_tag";
    TAGS[TAGS["END_OF_MALLOC"] = 11] = "END_OF_MALLOC";
    TAGS[TAGS["END_OF_FREE"] = -1] = "END_OF_FREE";
})(TAGS = exports.TAGS || (exports.TAGS = {}));
exports.TYPE_TO_TAG = {
    void: TAGS.void_tag,
    float: TAGS.float_tag,
    char: TAGS.char_tag,
    int: TAGS.int_tag,
    pointer: TAGS.pointer_tag
};
exports.TAG_TO_TYPE = {
    '0': 'void',
    '1': 'float',
    '2': 'int',
    '3': 'char',
    '4': 'pointer'
};
var MEM_TYPE;
(function (MEM_TYPE) {
    MEM_TYPE[MEM_TYPE["STACK"] = 0] = "STACK";
    MEM_TYPE[MEM_TYPE["HEAP"] = 1] = "HEAP";
})(MEM_TYPE = exports.MEM_TYPE || (exports.MEM_TYPE = {}));
//# sourceMappingURL=tags.js.map